import React, { useEffect, useState } from 'react'
import Table from '../../components/table/table';
import { GetListeGame } from '../../helpers/api';

const Gamification = () => {

  const [loading, setLoading]=useState(true)
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [dataresponse, setDataresponse] = useState([]);


  const columns = [
     {
      label: "Order",
      key: "order",
    },

    {
      label: "user",
      key: "firstName",
      customRenderers: (row) => (
        <div>
        {row.lastName} {row.firstName}
        </div>
      ),
    },
    {
      label: "Pack",
      key: "row.game?.pack",
      customRenderers: (row) => (
        <div>
          {row.game?.pack ?? "-"}
        </div>
      ),
    },
    {
      label: "Balance",
      key: "balance",
      customRenderers: (row) => (
        <div>
          {row.game?.balance ?? "-"}
        </div>
      ),    
    },
     {
      label: "Total Cadeaux",
      key: "giftCount",
       
    },
     {
      label: "Cadeaux Utilisés",
      key: "usedGiftCount",
       
    },
    {
      label: "Action",
      key: "Action",
      customRenderers: (row) => (
        <a 
          href={`/game-details/${row._id}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#111136] font-bold underline hover:text-blue-600"
        >
          voir plus
        </a>
      ),    
    },
  ]

   useEffect(()=>{
    const fetchaData= async()=>{
      try{
        const response = await GetListeGame(currentPage, pageSize)
        if(response.success)
        {
          setDataresponse(response.data)
          setLoading(false) 
          setPageSize(response.limit)
          setCurrentPage(response.page)
          setTotalPage(response.total)

        }   
      } catch (error) {
        console.error("Error getting user game details:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchaData()
  },[currentPage])

  return (
    <div className="bg-white rounded-[10px]  border border-slate-100 p-6">

     <Table
              setPageSize={setPageSize}
              pageSize={pageSize}
              currentPage={currentPage}
              totalPage={totalPage}
              setCurrentPage={setCurrentPage}
              data={dataresponse}
              message="Veuillez Sélectionner une action"
              columns={columns}
              loading={loading}
              excel={true}
              rowClassName={(row) => {
                const diff = (new Date(row.createdAt)) / 60000;
                return diff >= 5
                  ? " border-l-4 border-l-[#FF3B30]"
                  : "border-l-4  border-l-[#5754E5]";
              }}
            />
      
    </div>
  )
}

export default Gamification
